import { render, staticRenderFns } from "./NewAddModel.vue?vue&type=template&id=79fa558c"
import script from "./NewAddModel.vue?vue&type=script&lang=js"
export * from "./NewAddModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports